// extracted by mini-css-extract-plugin
export var inlineLink = "_83-0";
export var inlineLinkButton = "_83-1";